import React from 'react'

export default function Text(props) {
  return <div style={{ marginTop: 8, ...props.style }}>{props.children}</div>
}
